import React, {useEffect, useState} from "react";
import HubBodyLayout from '../../../Layouts/Hub/components/hub-body-layout';
import { HubPresentation } from '../Shared/HubPresentation';
import BarcodeInput from '../Shared/BarcodeInput';
import {Spinner} from "react-bootstrap";
import {useScanStatusUpdate} from "../Shared/hooks/use-scan-status-update";
import {swalError, swalSuccess} from "../../../Components/sweetAlert";
import {useTranslation} from "react-i18next";
import {format, parse} from "date-fns";
import {useGetLeftOver} from "../Shared/hooks/use-get-left-over";
import {ScanInOut} from "../Shared/ScanInOut";
import { LeftOverTable } from "../Shared/LeftOverTable";
import { LeftOverStats } from "../Shared/LeftOverStats";


const getDateFilters = (dates) => {
    return {
        startDate: parse(format(dates.startDate, 'yyyy/MM/dd 00:00:00'), 'yyyy/MM/dd HH:mm:ss', new Date()),
        endDate: parse(format(dates.endDate, 'yyyy/MM/dd 23:59:00'), 'yyyy/MM/dd HH:mm:ss', new Date())
    }
};

const getAPIDates = (dates) => {
    return {
        startDate: format(dates.startDate, 'yyyy-MM-dd 00:00:00'),
        endDate: format(dates.endDate, 'yyyy-MM-dd 23:59:00')
    }
}

const LeftOver = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage2, setCurrentPage2] = useState(1);
    const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
    const [awb_code, setAwb_code] = useState('');
    const [dateFilters, setDateFilters] = useState(getDateFilters({
        startDate: yesterday,
        endDate: new Date()
    }));

    const  {loading: dataLoading, data, fetch} = useGetLeftOver((error) => {
        void swalError({
            text: error
        })
    });

    const initialFetch = () => {
        setCurrentPage(1);
        fetch(1,1, 1, getAPIDates(dateFilters));
    }

    useEffect(() => {
        initialFetch();
    }, []);

    useEffect(() => {
        console.log(dateFilters);
    }, [dateFilters]);

  const {t} = useTranslation();
  const {loading: updateStatusLoading, updateStatus} = useScanStatusUpdate(
      1,
      (error) => {
          void swalError({
              text: error
          })
      },
      (message) => {
            void swalSuccess({
                text: message,
            });
          initialFetch();
      }
  );

  const loading = dataLoading || updateStatusLoading;



  const handleDateFiltersChanged = (filters) => {
      setDateFilters(filters);
      setCurrentPage(1);
      void fetch(currentPage,currentPage2, 1, getAPIDates(filters))
  }

  const handleChangePage = (event,page) => {
      setCurrentPage(page);
      void fetch(page,currentPage2, 1, getAPIDates(dateFilters))
  }

  const handleChangePage2 = (event,page) => {
    setCurrentPage2(page);
    void fetch(currentPage,page, 1, getAPIDates(dateFilters))
}

  const leftContent = (
    <>
      <HubPresentation />
        {loading &&
            <div className="spinner-global-content">
                <Spinner variant="success" animation="border" />
            </div>
        }
        {!loading && (
            <>
                {/* <BarcodeInput
                    value={awb_code}
                    setValue={setAwb_code}
                    placeholder={t('hub.scan.barcode_input')}
                    submit={updateStatus.bind(null,awb_code)} /> */}
                <LeftOverStats
                    dateFilters={dateFilters}
                    setDateFilters={handleDateFiltersChanged}
                    loading={loading}
                    data={data}
                    handleChangePage={handleChangePage}
                />
                <LeftOverTable
                    dateFilters={dateFilters}
                    setDateFilters={handleDateFiltersChanged}
                    loading={loading}
                    data={data}
                    handleChangePage={handleChangePage}
                    handleChangePage2={handleChangePage2}
                />
            </>
        )}
    </>
  );

  return (
    <HubBodyLayout leftContent={leftContent}/>
  )
}
export default LeftOver;
